export class Validator{
    init(){
        $(document).ready(function() {
            if ($('.site-content form').length) {
                $('.grecaptcha-badge').addClass('show');
            }
        });

        $('input, textarea').keydown(function() {
                $(this).siblings('label').addClass('focus');
        });

        $('input, textarea').focusout(function() {
                if($(this).val().length == 0){
                        $(this).siblings('label').removeClass('focus');
                }
        });

        $.extend($.validator.messages, {
            required: "To pole jest wymagane.",
            remote: "Proszę o wypełnienie tego pola.",
            email: "Proszę o podanie prawidłowego adresu email.",
            url: "Proszę o podanie prawidłowego URL.",
            date: "Proszę o podanie prawidłowej daty.",
            dateISO: "Proszę o podanie prawidłowej daty (ISO).",
            number: "Proszę o podanie prawidłowej liczby.",
            digits: "Proszę o podanie samych cyfr.",
            creditcard: "Proszę o podanie prawidłowej karty kredytowej.",
            equalTo: "Proszę o podanie tej samej wartości ponownie.",
            extension: "Proszę o podanie wartości z prawidłowym rozszerzeniem.",
            nipPL: "Proszę o podanie prawidłowego numeru NIP.",
            phonePL: "Proszę o podanie prawidłowego numeru telefonu.",
            maxlength: $.validator.format("Proszę o podanie nie więcej niż {0} znaków."),
            minlength: $.validator.format("Proszę o podanie przynajmniej {0} znaków."),
            rangelength: $.validator.format("Proszę o podanie wartości o długości od {0} do {1} znaków."),
            range: $.validator.format("Proszę o podanie wartości z przedziału od {0} do {1}."),
            max: $.validator.format("Proszę o podanie wartości mniejszej bądź równej {0}."),
            min: $.validator.format("Proszę o podanie wartości większej bądź równej {0}."),
            pattern: $.validator.format("Pole zawiera niedozwolone znaki.")
        });

        $.validator.addMethod('filesize', function (value, element, param) {
            let result = true;

            if (element.files.length === 0) {
                return result;
            }

            Array.from(element.files).forEach(file => {
                result &= file.size <= param;
            });

            return result;
        }, 'Rozmiar pliku musi być mniejszy niż {0}B');

        if(typeof contactFormRules == 'object'){
            var $_FORM = $('#contactForm'),
            submitHandler = function(form) {
                event.preventDefault();
                if (typeof grecaptcha !== 'undefined') {
                    var recaptchaResponse = grecaptcha.getResponse();
                    if (recaptchaResponse) {
                        ajaxCall();
                    } else {
                        alert("Proszę zaznaczyć reCAPTCHA.");
                    }
                } else {
                    console.log("reCAPTCHA nie jest załadowana.");
                }

            },
            ajaxCall = function(appendData) {
                return $.ajax({
                            url: $_FORM.attr("action"),
                            method: 'POST',
                            data: ajaxData(appendData),
                            beforeSend: ajaxBeforeSend,
                            success: ajaxSuccess,
                            error: ajaxError
                        });
            },
            ajaxData = function(appendData) {
                var serialized = $_FORM.serialize();

                if( typeof appendData !== 'object' )
                {
                    return serialized;
                }

                $.each(appendData, function(key, value) {
                    serialized += '&' + key + '=' + value;
                });

                return serialized;
            },
            ajaxBeforeSend = function() {
                $_FORM.find('button').prop('disabled', 'disabled');
            },
            ajaxSuccess = function() {
                callFbq();

                $_FORM.find('input, textarea').val('');
                $_FORM.fadeOut(500, function () {
                    $_FORM.replaceWith('<p class="form__message form__message--success">Wiadomość została wysłana. Dziękujemy.</p>').fadeIn(500);
                });
            },
            ajaxError = function() {
                $_FORM.find('input, textarea').val('');
                $_FORM.fadeOut(500, function ()
                {
                    $_FORM.replaceWith('<p class="form__message form__message--error">Wiadomość nie została wysłana. Prosimy spróbować później.</p>').fadeIn(500);
                });
            },
            callFbq = function() {
                if( typeof fbq === 'function' )
                {
                    fbq('track', 'Lead');
                }
            };

            $_FORM.validate({
                rules: contactFormRules,
                errorPlacement: function(error, element) {},
                submitHandler: submitHandler
            });

        }

        if (typeof accreditationFormRules == 'object') {
            $('#accreditationForm').submit(function (event) {
                event.preventDefault();
                event.stopPropagation();
            });

            $('#accreditationForm').validate({
                rules: accreditationFormRules,
                lang: 'pl',
                errorPlacement: function (error, element) {
                    error.appendTo(element.parent("div"));
                },
                submitHandler: function (form) {
                    form.submit();
                }
            });
        }
    }
}